import React, { FC } from 'react';
import styled from 'astroturf/react';

import { Icon } from 'js/design_system/Icon';

const Row = styled.div`
  font-size: 15px;
  letter-spacing: -0.01em;
  color: #222222;
  height: 36px;
  padding: 0 20px;
  cursor: pointer;

  &:hover {
    background-color: #e6eefc;
  }
`;

const AlignCenterJusitfyApart = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 36px; // firefox doesn't like height: 100%
`;

type Props = {
  name: string;
  isSelected: boolean;
  onClick: () => void;
};

const LanguageRow: FC<Props> = ({ name, isSelected, onClick }) => (
  <Row onClick={onClick}>
    <AlignCenterJusitfyApart>
      {name}
      {isSelected && <Icon name="check" color="#094ec3" />}
    </AlignCenterJusitfyApart>
  </Row>
);

export default LanguageRow;
